<template>
  <NutritionTracker />
</template>

<script>
import NutritionTracker from './components/NutritionTracker.vue'

export default {
  name: 'App',
  components: {
    NutritionTracker
  }
}
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 20px;
  }
</style>
